import { getbadgenum } from '@/api/contract/contract'

/**
 * 消息记录
 */
const app = {
	state: {
		// 详情的角标
		badgeNum: {
			id:0,
			record: 0,
			finance: 0,
			complain:0
		}
	},

	mutations: {
		
		/**
		 * 更改角标
		 */
		SET_BADGENUM: (state, badgeNum) => {
			state.badgeNum = badgeNum
		},
		
		// 角标+1
		incrementByContract:(state, type) => {
			state.badgeNum[type]++
		},
		
		// 角标-1
		descrementByContract:(state, type) => {
			state.badgeNum[type]--
		},
		
		// 清空数据
		emptybadgeByContract:(state) => {
			state.badgeNum = {
				id:0,
				record: 0,
				finance: 0,
				complain:0
			}
		}
	},

	actions: {
		// 角标
		GetContractBadgeNum({
			commit
		}, id) {
			return new Promise((resolve, reject) => {
				getbadgenum({id:id})
					.then(response => {
						commit('SET_BADGENUM', response.data)
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		}
	}
}

export default app
